import crossTokenMainnet from './cross-token-mainnet.json'
import crossTokenTesnet from './cross-token-testnet.json'
import foreignCoinsMainnet from './foreign-coins-mainnet.json'
import foreignCoinsTesnet from './foreign-coins-testnet.json'

export const CROSS_TOKENS = [...crossTokenMainnet.tokens, ...crossTokenTesnet.tokens]
export const FOREIGN_TOKENS = [...foreignCoinsMainnet.foreignCoins, ...foreignCoinsTesnet.foreignCoins]
